import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateBlockV3 = OpalApi<'CreateBlockV3', 201>

export const createBlock: CreateBlockV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/blocks/', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
